import { Column, RowData } from '@tanstack/react-table';
import Code95Filter from './Code95Filter';
import BooleanFilter from './BooleanFilter';
import IsBeforeFilter from './IsBeforeFilter';
import React from 'react';
import TextFilter from './TextFilter';

declare module '@tanstack/react-table' {
	// eslint-disable-next-line
	interface ColumnMeta<TData extends RowData, TValue> {
		filterVariant: 'code95Filter' | 'boolean' | 'expirationDate' | 'text';
		filterLabel?: string;
	}
}

export default function Filter({ column }: { column: Column<any, unknown> }) {
	const { filterVariant, filterLabel } = column.columnDef.meta ?? {};
	if (filterVariant === 'code95Filter') {
		return <Code95Filter column={column} />;
	}

	if (filterVariant === 'boolean') {
		return <BooleanFilter column={column} />;
	}

	if (filterVariant === 'expirationDate') {
		return <IsBeforeFilter column={column} label={filterLabel || ''} />;
	}

	if (filterVariant === 'text') {
		return <TextFilter column={column} />;
	}

	return null;
}
